import React from "react"

import { useState } from "react"
import { Card, Container, Row, Col, Button, Form, Accordion } from "react-bootstrap"
import { FaPhone, FaSearch, FaComments, FaEnvelope, FaQuestionCircle,FaFacebook,FaWhatsapp,FaInstagram,FaYoutube } from "react-icons/fa"
import Footer from "./Footer"

export default function FAQPage() {
  const [searchTerm, setSearchTerm] = useState("")

  const faqs = [
    {
      category: "General",
      questions: [
        {
          question: "How does Aidify work?",
          answer:
            "Aidify connects patients with doctors through our 24/7 booking service. Simply call us, describe your medical needs, and we'll find and book an appointment with the most suitable Aidify professional in your area.",
        },
        {
          question: "Is Aidify available 24/7?",
          answer:
            "Yes! Our booking service operates 24 hours a day, 7 days a week. Whether it's 3 AM or a holiday, our team is ready to help you connect with Aidify professionals.",
        },
        {
          question: "What types of medical conditions do you handle?",
          answer:
            "We handle a wide range of medical conditions from routine check-ups to urgent care needs. Our network includes specialists in cardiology, neurology, orthopedics, pediatrics, and many other medical fields.",
        },
        {
          question: "How quickly can I get an appointment?",
          answer:
            "Most appointments are booked within 15-30 minutes of your call. For urgent cases, we can often arrange same-day appointments, while routine visits may be scheduled within 24-48 hours.",
        },
      ],
    },
    {
      category: "Booking & Appointments",
      questions: [
        {
          question: "How do I book an appointment?",
          answer:
            "Simply call our hotline at +92 300 1243439. Our trained staff will assess your needs, find the right doctor, and book your appointment. We handle all the coordination for you.",
        },
        {
          question: "Can I choose my doctor?",
          answer:
            "While we match you with the most suitable doctor based on your condition and location, you can express preferences. We'll do our best to accommodate your requests while ensuring you get the best care.",
        },
        {
          question: "What if I need to cancel or reschedule?",
          answer:
            "You can cancel or reschedule by calling us at least 24 hours before your appointment. We'll coordinate with the doctor's office and find you a new suitable time slot.",
        },
       
      ],
    },
    {
      category: "Costs & Transportation",
      questions: [
        {
          question: "How much does Aidify service cost?",
          answer:
            "Our booking service is completely free for patients. You only pay the doctor's consultation fee directly to the Aidify provider. There are no hidden charges from Aidify.",
        },
       {
  question: "Do you operate in all areas?",
  answer:
    "We provide transportation services across most major cities and regions. During booking, we'll confirm that your chosen route is covered to ensure a smooth trip.",
},
{
  question: "What if I don't have a vehicle?",
  answer:
    "We can connect you with drivers or rental services offering competitive rates. Many of our partners provide discounted packages for customers without their own transportation.",
},

      ],
    },
    {
      category: "Emergency Services",
      questions: [
        {
          question: "Do you handle medical emergencies?",
          answer:
            "For life-threatening emergencies, please call 911 immediately. Aidify specializes in urgent but non-emergency medical needs and connecting you with appropriate care quickly.",
        },
        {
          question: "What constitutes an urgent medical need?",
          answer:
            "Urgent needs include severe pain, high fever, persistent symptoms, medication concerns, or any health issue that needs prompt attention but isn't life-threatening.",
        },
        {
          question: "Can you arrange emergency room visits?",
          answer:
            "While we don't arrange ER visits (call 911 for emergencies), we can help you find urgent care centers or after-hours clinics that can address your immediate medical needs.",
        },
      ],
    },
  ]

  const filteredFAQs = faqs
    .map((category) => ({
      ...category,
      questions: category.questions.filter(
        (faq) =>
          faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
          faq.answer.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    }))
    .filter((category) => category.questions.length > 0)

  return (
    <div className="min-vh-100">
      {/* Hero Section */}
      <section
        className="position-relative overflow-hidden py-5"
        style={{
          background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
          minHeight: "60vh",
        }}
      >
        {/* Animated Background Elements */}
        {/* <div className="position-absolute w-100 h-100">
          <div
            className="position-absolute rounded-circle opacity-10"
            style={{
              width: "200px",
              height: "200px",
              background: "white",
              top: "20%",
              right: "15%",
              animation: "float 6s ease-in-out infinite",
            }}
          ></div>
          <div
            className="position-absolute rounded-circle opacity-10"
            style={{
              width: "150px",
              height: "150px",
              background: "white",
              bottom: "25%",
              left: "10%",
              animation: "float 8s ease-in-out infinite reverse",
            }}
          ></div>
        </div> */}

        <Container className="position-relative">
          <div className="text-center text-white py-5">
            <div
              className="d-inline-flex align-items-center px-4 py-2 rounded-pill mb-4"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.3)",
              }}
            >
              <FaQuestionCircle className="me-2" />
              <span className="fw-medium">Help Center</span>
            </div>

            <h1 className="display-3 fw-bold mb-4">Frequently Asked Questions</h1>
            <p className="fs-5 mb-5 opacity-90" style={{ maxWidth: "700px", margin: "0 auto", lineHeight: "1.6" }}>
              Find answers to common questions about our Aidify booking service
            </p>

            {/* Search Bar */}
            <div className="position-relative mx-auto" style={{ maxWidth: "500px" }}>
              <div
                className="position-absolute top-50 start-0 translate-middle-y ms-4 text-white opacity-75"
                style={{ zIndex: 2 }}
              >
                <FaSearch size={18} />
              </div>
              <Form.Control
                type="text"
                placeholder="Search FAQs..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="ps-5 py-3 border-0 rounded-pill"
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  backdropFilter: "blur(20px)",
                  fontSize: "16px",
                  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
                }}
              />
            </div>
          </div>
        </Container>
      </section>

      {/* Quick Contact Banner */}
      <section
        className="py-4"
        style={{
          background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
        }}
      >
        <Container>
          <div className="text-center text-white">
            <h3 className="h5 fw-bold mb-2">Can't find what you're looking for?</h3>
            <p className="mb-3 opacity-90">Our support team is available 24/7 to answer your questions</p>
            <Button
              variant="light"
              className="px-4 py-2 rounded-pill fw-bold"
              style={{
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
              }}
            >
              <FaPhone className="me-2" style={{ color: "#0891b2" }} />
              <span style={{ color: "#0891b2" }}> +92 300 1243439</span>
            </Button>
          </div>
        </Container>
      </section>

      {/* FAQ Sections */}
      <section className="py-5" style={{ backgroundColor: "#f8fffe" }}>
        <Container>
          {filteredFAQs.length > 0 ? (
            <Row className="g-4">
              {filteredFAQs.map((category, categoryIndex) => (
                <Col lg={6} key={categoryIndex}>
                  <Card
                    className="border-0 rounded-4 h-100"
                    style={{
                      boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                      transform: "translateY(0)",
                      transition: "all 0.3s ease",
                      backgroundColor: "#f0fdfa",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)"
                      e.currentTarget.style.boxShadow = "0 15px 50px rgba(0, 0, 0, 0.12)"
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)"
                      e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.08)"
                    }}
                  >
                    <Card.Header
                      className="border-0 rounded-top-4 p-4"
                      style={{
                        background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                      }}
                    >
                      <Card.Title className="text-white mb-1 h4 fw-bold">{category.category}</Card.Title>
                      <Card.Text className="text-white opacity-90 mb-0">
                        Common questions about {category.category.toLowerCase()}
                      </Card.Text>
                    </Card.Header>
                    <Card.Body className="p-0">
                      <Accordion flush>
                        {category.questions.map((faq, faqIndex) => (
                          <Accordion.Item key={faqIndex} eventKey={`${categoryIndex}-${faqIndex}`} className="border-0">
                            <Accordion.Header className="fw-medium">{faq.question}</Accordion.Header>
                            <Accordion.Body className="text-muted" style={{ lineHeight: "1.6" }}>
                              {faq.answer}
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                      </Accordion>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <Card
              className="border-0 rounded-4"
              style={{
                boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                backgroundColor: "#f0fdfa",
              }}
            >
              <Card.Body className="text-center py-5">
                <div
                  className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center"
                  style={{
                    width: "100px",
                    height: "100px",
                    background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                    boxShadow: "0 10px 30px rgba(8, 145, 178, 0.3)",
                  }}
                >
                  <FaSearch size={40} className="text-white" />
                </div>
                <h3 className="h4 fw-bold mb-3" style={{ color: "#1f2937" }}>
                  No results found
                </h3>
                <p className="text-muted mb-4">Try adjusting your search terms or contact us directly</p>
                <Button
                  variant="primary"
                  className="px-4 py-2 rounded-pill fw-medium"
                  style={{
                    background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                    border: "none",
                  }}
                >
                  <FaPhone className="me-2" />
                  Contact Support
                </Button>
              </Card.Body>
            </Card>
          )}
        </Container>
      </section>

      {/* Contact Options */}
      <section className="py-5" style={{ backgroundColor: "white" }}>
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-6 fw-bold mb-4" style={{ color: "#1f2937" }}>
              Still Need Help?
            </h2>
            <p className="fs-5 text-muted">Multiple ways to get the support you need</p>
          </div>

          <Row className="g-4">
            {[
              {
                icon: FaPhone,
                title: "Call Us",
                description: "Speak with our support team 24/7",
                action: "+92 300 1243439",
                gradient: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                variant: "danger",
              },
              {
                icon: FaComments,
                title: "Live Chat",
                description: "Chat with our support agents online",
                action: "Start Chat",
                gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
                variant: "success",
              },
              {
                icon: FaEnvelope,
                title: "Email",
                description: "Send us your questions via email",
                action: "support@aidify.pk",
                gradient: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
                variant: "info",
              },
            ].map((option, index) => (
              <Col md={4} key={index}>
                <Card
                  className="text-center border-0 rounded-4 h-100"
                  style={{
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                    transform: "translateY(0)",
                    transition: "all 0.4s ease",
                    backgroundColor: "#f0fdfa",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)"
                    e.currentTarget.style.boxShadow = "0 20px 60px rgba(0, 0, 0, 0.15)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.08)"
                  }}
                >
                  <Card.Body className="p-5">
                    <div
                      className="rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center"
                      style={{
                        width: "80px",
                        height: "80px",
                        background: option.gradient,
                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      <option.icon size={32} className="text-white" />
                    </div>
                    <Card.Title className="h4 fw-bold mb-3" style={{ color: "#1f2937" }}>
                      {option.title}
                    </Card.Title>
                    <Card.Text className="text-muted mb-4">{option.description}</Card.Text>
                    <Button
                      className="w-100 rounded-pill fw-medium border-0"
                      style={{
                        background: option.gradient,
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                        transform: "translateY(0)",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)"
                        e.target.style.boxShadow = "0 6px 20px rgba(0, 0, 0, 0.3)"
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)"
                        e.target.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.2)"
                      }}
                    >
                      {option.action}
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
       
       <Footer/>
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
      `}</style>
    </div>
  )
}
